<template>
  <div
    class="align-center d-flex"
    :class="showSMSRetryMessage ? 'visible' : 'hidden'"
  >
    <v-icon color="#e21b23" class="d-flex align-self-start mt-1"
      >mdi-alert-outline</v-icon
    >
    <div class="color-fire-engine-red font-weight-semibold ml-1">
      <p class="line-height-1">
        There was a problem with confirmation of your verification code.
      </p>
      <p>Please confirm code and try again.</p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "AuthElementsSMSError",
  computed: {
    ...mapState({
      showSMSRetryMessage: (state) => state.auth.showSMSRetryMessage,
    }),
  },
  mounted() {
    this.$store.commit("auth/SHOW_SMS_RETRY_MESSAGE", false);
  },
};
</script>
